import { ApiService } from "../../config";
import { Commons } from "../../utilities";
import { actionTypeAdmin } from "../types";


export const getDoctorsByPhoneNumorEmail = (search, languageId) => async (dispatch) => {
    dispatch({ type: actionTypeAdmin.GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_REQUEST });
    try {
        const queryParams = Commons.addQueryParameter({ search, languageId });
        const response = await ApiService.get(
            `/admin/getdoctersbyphonenumoremail?${queryParams}`
        );
        const responsePayload = {
            data: response.data,
            status: response.status,
        };

        dispatch({
            type: actionTypeAdmin.GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_SUCCESS,
            payload: responsePayload,
        });

    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };
        dispatch({
            type: actionTypeAdmin.GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_FAILURE,
            payload: errorPayload,
        });
    }
};


export const getPatientViewDetails = (patientGuid, LanguageId) => async (dispatch) => {
    dispatch({ type: actionTypeAdmin.GET_PATIENT_VIEW_DETAILS_REQUEST });
    try {
        const queryParams = Commons.addQueryParameter({ patientGuid, LanguageId });
        const response = await ApiService.get(
            `/admin/patientviewdetails?${queryParams}`
        );
        const responsePayload = {
            data: response.data,
            status: response.status,
        };

        dispatch({
            type: actionTypeAdmin.GET_PATIENT_VIEW_DETAILS_SUCCESS,
            payload: responsePayload,
        });

    } catch (error) {
        const errorPayload = {
            status: error.response?.status,
            data: error.response?.data,
        };
        dispatch({
            type: actionTypeAdmin.GET_PATIENT_VIEW_DETAILS_FAILURE,
            payload: errorPayload,
        });
    }
};


const actionAdmin = {
    getDoctorsByPhoneNumorEmail,
    getPatientViewDetails
}
export default actionAdmin;
